export enum DisplaysActionKeys {
  DELELTE_DISPLAY_CONFIG = 'DELELTE_DISPLAY_CONFIG',
  FETCH_DISPLAY_CONFIGS = 'FETCH_DISPLAY_CONFIGS',
  REMOVE_DISPLAY_CONFIG = 'REMOVE_DISPLAY_CONFIG',
  SET_DISPLAY_CONFIGS = 'SET_DISPLAY_CONFIGS',
  UPDATE_DISPLAY_CONFIG = 'UPDATE_DISPLAY_CONFIG'
}
